export { default } from './PartitionObjectsPage.vue'
